var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-view-stage-3-custom"
  }, [_c('document-cloud-handler', {
    attrs: {
      "cloud-meta": _vm.getCloudMeta(),
      "rules": ['single'],
      "class-cst": 'cloud-button add-obhliadka white--text no-decoration',
      "icon-button": ""
    }
  }), _c('documents-zip-download'), _c('div', {
    staticClass: "podpis-event-banner"
  }, [_vm._m(0), _c('div', {
    staticClass: "div-block-146"
  }, [_c('button', {
    staticClass: "w-button",
    on: {
      "click": _vm.copyCloudRequiredFiles
    }
  }, [_vm._v(" Kopírovať zoznam ")])])]), _vm.loaded ? _c('div', {
    staticClass: "stage-3-items-wrapper"
  }, _vm._l(_vm.clouds, function (cloud, key) {
    return _vm.showCloud(cloud) ? _c('mortgage-item-cloud', {
      key: key,
      attrs: {
        "object": cloud
      }
    }) : _vm._e();
  }), 1) : _c('div', {
    staticClass: "d-flex justify-content-center align-items-center",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-142"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f3b_document%20icon.png",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-143"
  }, [_c('div', {
    staticClass: "bold blc-color"
  }, [_vm._v("Pošlite klientovi zoznam požadovaných dokumentov jedným klikom")])])]);

}]

export { render, staticRenderFns }